import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import AdminDashboard from "@/pages/AdminDashboard";
import BlogPostPage from "@/pages/BlogPostPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin/*" element={<AdminDashboard />} />
          <Route path="/blog/:id" element={<BlogPostPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
      <div className="grain-overlay" />
    </div>
  );
}

export default App;
